import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { FooterModule } from './components/footer/footer.module';
import { HeaderModule } from './components/header/header.module';
import { SideNavBarModule } from './components/side-navbar/side-navbar.module';
import { HomeComponent } from './pages/home/home.component';
import { ReviewCardComponent } from './pages/home/review-card/review-card.component';
import { UpdateCardComponent } from './pages/home/update-card/update-card.component';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  MsalGuard,
  MsalBroadcastService,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalRedirectComponent,
} from '@azure/msal-angular';

import {
  MSALInterceptorConfigFactory,
  MSALGuardConfigFactory,
  MSALInstanceFactory,
} from './msal-config';
import { CommonModule } from '@angular/common';
import { LogoutComponent } from './pages/logout/logout.component';
import { BackendAPIInterceptor } from './services/auth.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMxWebComponentsModule } from 'ng-mx-web-components';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LogoutComponent,
    ReviewCardComponent,
    UpdateCardComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    FooterModule,
    HeaderModule,
    HttpClientModule,
    MsalModule,
    SideNavBarModule,
    ReactiveFormsModule,
    FormsModule,
    NgMxWebComponentsModule,
  ],
  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BackendAPIInterceptor,
      multi: true,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
